// Render Order
export const FRONT_RENDER_ORDER = 1
export const BACK_RENDER_ORDER = 2
export const WIRE_RENDER_ORDER = 3
export const OVERLAY_RENDER_ORDER = 4

// Layers
export const DEFAULT_LAYER = 0
export const INTERACTION_LAYER = 1
export const WIREFRAME_LAYER = 2
export const BACKSIDE_LAYER = 3

// Camera
export const DISTANCE_FACTOR = 1.3
export const DEFAULT_CAMERA_NEAR = 0.001
export const CAMERA_FAR_FACTOR = 50

// Canvas
export const CANVAS_SIZE = {
  WIDTH: 1080,
  HEIGHT: 1024,
}
export const ASPECT = CANVAS_SIZE.WIDTH / CANVAS_SIZE.HEIGHT
export const DEFAULT_VIEW_HEIGHT = 180
export const DEFAULT_VIEW_WIDTH = DEFAULT_VIEW_HEIGHT * ASPECT
export const MIN_VIEW_WIDTH = 20
export const MIN_VIEW_HEIGHT = MIN_VIEW_WIDTH / ASPECT

// Image Data
export const IMAGE_DATA_VERSION = 1
